(function ( $ ) {
 
    $.fn.counter = function() {
        this.each(function(){
        	var selfDiv = this;
        	var hePintado = false;
        	this.isScrolledIntoView = function(elem){
			    var $elem = $(elem);
			    var $window = $(window);

			    var docViewTop = $window.scrollTop();
			    var docViewBottom = docViewTop + $window.height();

			    var elemTop = $elem.offset().top;
			    var elemBottom = elemTop + $elem.height();

			    return ((elemBottom <= docViewBottom) && (elemTop >= docViewTop));
			}

	        this.init = function(){
	        	var text = $(this).text();
		        var newHtml = [];
		        for(var cont=0;cont<text.length;cont++){
		        	var num = text[cont];
		        	if(!isNaN(num)){
		        		newHtml.push("<span class='counter_number' ><span class='counter_number_inner' data-value='"+num+"'>0<br/>1<br/>2<br/>3<br/>4<br/>5<br/>6<br/>7<br/>8<br/>9<br/>0<br/>1<br/>2<br/>3<br/>4<br/>5<br/>6<br/>7<br/>8<br/>9</span></span>");
		        	}else{
		        		newHtml.push("<span class='counter_'>"+num+"</span>");
		        	}
		        }
		        $(this).html(newHtml.join(""));
		        selfDiv.pintoono();
	        }
	        this.pintoono = function(){
	        	if(selfDiv.isScrolledIntoView(selfDiv) && !hePintado){
		        	selfDiv.draw();
	        	}
	        }
	        $(window).on("scroll",function(){
	        	selfDiv.pintoono();
	        });


	        this.draw = function(){
	        	hePintado = true;
	        	var self = this;
	        	setTimeout(function(){
		        	$(self).find(".counter_number_inner").each(function(){
			        	var selftwo = this;
		        		var num_c = $(this).attr("data-value"); 
		        		var rand = Math.floor((Math.random() * 9) + 0);

		        		//transition-delay: 0.2s;
			        	//$(this).css({"transition-delay": "0."+rand+"s","-webkit-transform": "translateY(-50%) translateZ(0)","transform": "translateY(-50%) translateZ(0)"});
		        		if(num_c==0){
			        		$(this).css({"transition-delay": "0."+rand+"s","-webkit-transform": "translateY(-50%) translateZ(0)","transform": "translateY(-50%) translateZ(0)"});
		        		}else{
				        	$(this).css({"transition-delay": "0."+rand+"s","-webkit-transform": "translateY(-"+((num_c*10)/2)+"%) translateZ(0)","transform": "translateY(-"+((num_c*10)/2)+"%) translateZ(0)"});
				        }
		        	})
		        },100);
	        	//--cmp-speedometer-fractional-translation: -77.98%;
    			//transition-delay: 0.2s;
	        }
	        this.init();

	        return this;
	    })
    };
 
}( jQuery ));